var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.5,
    height: 156.258,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "plusButton_svg__a",
    x: 0,
    y: 0,
    width: 87.5,
    height: 156.258,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#cbcbcb",
    floodOpacity: 0.549
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": ".target-image"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.002)",
    filter: "url(#plusButton_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u5408\\u4F53 13",
    d: "M16.003 152.756a16 16 0 01-16-16v-80a15.994 15.994 0 01.716-4.747 11.827 11.827 0 012.354-7.367L32.339 4.885a12 12 0 0119.328 0l29.266 39.757a11.826 11.826 0 012.354 7.367 15.994 15.994 0 01.716 4.747v80a16 16 0 01-16 16z",
    fill: "#76b788"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 122",
    fill: "none",
    stroke: "#000",
    strokeWidth: 8,
    d: "M40.902 74.66v-38"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u7DDA 123",
    fill: "none",
    stroke: "#000",
    strokeWidth: 8,
    d: "M21.902 55.66h38"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusButton);
export default __webpack_public_path__ + "static/media/plusButton.efc532bd22f7f684.svg";
export { ForwardRef as ReactComponent };